import { createGlobalStyle } from 'styled-components';

// GlobalStyle unique — l'échelle typographique et les couleurs de fond
// viennent du thème (theme.js). L'ancienne échelle h1=67px est abandonnée.
export const GlobalStyle = createGlobalStyle`
    *, *::before, *::after {
        box-sizing: border-box;
    }
    html {
        font-size: 100%; /* 16px */
    }
    body {
        margin: 0;
        font-family: 'Mulish', 'Segoe UI', system-ui, sans-serif;
        font-weight: 400;
        font-size: ${(props) => props.theme.type.body};
        line-height: 1.5;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        letter-spacing: 0.01rem;
        color: ${(props) => props.theme.text};
        background: ${(props) => props.theme.ground};
        transition: background 0.15s linear, color 0.15s linear;
    }
    h1, h2, h3, h4, h5 {
        font-family: 'Mulish', 'Segoe UI', system-ui, sans-serif;
        font-weight: 700;
        text-wrap: balance;
    }
    h1 { font-size: ${(props) => props.theme.type.pageTitle}; font-weight: 800; }
    h2 { font-size: 1.3rem; font-weight: 800; }
    h3 { font-size: 1.15rem; }
    h4 { font-size: ${(props) => props.theme.type.cardTitle}; }
    h5 { font-size: 0.95rem; }
    small { font-size: ${(props) => props.theme.type.caption}; }

    :focus-visible {
        outline: 2px solid ${(props) => props.theme.accent};
        outline-offset: 2px;
        border-radius: ${(props) => props.theme.radius.sm};
    }

    /* ─── Barre de défilement, identique sur tout le site ───
       Le modèle retenu est celui de la modale de détail utilisateur de la
       recherche avancée : 6 px, piste transparente, curseur en borderStrong.
       Elle était jusqu'ici redéfinie dans dix blocs répartis sur sept fichiers,
       avec quatre largeurs différentes et des pistes tantôt transparentes,
       tantôt colorées. Une règle unique ici évite qu'un nouveau conteneur
       défilant reparte avec son propre style.

       scrollbar-width et scrollbar-color couvrent Firefox, qui ignore les
       pseudo-éléments -webkit- : il affichait donc la barre du système partout,
       ce qu'aucune des dix définitions ne corrigeait. */
    * {
        scrollbar-width: thin;
        scrollbar-color: ${(props) => props.theme.borderStrong} transparent;
    }
    ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
    }
    ::-webkit-scrollbar-track {
        background: transparent;
    }
    ::-webkit-scrollbar-thumb {
        background-color: ${(props) => props.theme.borderStrong};
        border-radius: ${(props) => props.theme.radius.sm};
    }
    ::-webkit-scrollbar-thumb:hover {
        background-color: ${(props) => props.theme.text3};
    }
    /* Angle entre barres horizontale et verticale : sans cette règle il reste
       peint en gris système et trahit le thème sombre. */
    ::-webkit-scrollbar-corner {
        background: transparent;
    }

    @media (prefers-reduced-motion: reduce) {
        *, *::before, *::after {
            transition: none !important;
            animation: none !important;
        }
    }
`;

export default GlobalStyle;
